/**
 * Staff roles come back in mixed casing ("ADMIN", "Doctor", "nurse") because
 * they are stored as free text rather than a fixed vocabulary. Title-case them
 * for display so a column of roles reads consistently; underscores become
 * spaces ("ROLE_PATIENT" -> "Role Patient").
 */
export const formatRole = (role) => {
  if (!role) return "Unknown";

  return String(role)
    .replace(/_/g, " ")
    .toLowerCase()
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
